import { types } from 'mobx-state-tree';

const SelectOption = types.model('SelectOption', {
  label: types.string,
  value: types.number,
});

export default SelectOption;
